import { Button } from "@/marketing/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface InfluencerTablePaginationProps {
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  onPageChange: (pageIndex: number) => void;
}

export function InfluencerTablePagination({
  pageIndex,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
}: InfluencerTablePaginationProps) {
  const start = totalCount === 0 ? 0 : pageIndex * pageSize + 1;
  const end = Math.min((pageIndex + 1) * pageSize, totalCount);

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-4">
      <p className="tw-text-sm tw-text-muted-foreground">
        Showing{" "}
        <span className="tw-font-medium tw-text-foreground">
          {start.toLocaleString()}-{end.toLocaleString()}
        </span>{" "}
        of{" "}
        <span className="tw-font-medium tw-text-foreground">
          {totalCount.toLocaleString()}
        </span>
      </p>
      <div className="tw-flex tw-items-center tw-gap-2">
        <Button
          variant="outline"
          size="sm"
          className="tw-h-8 tw-gap-1"
          onClick={() => onPageChange(pageIndex - 1)}
          disabled={pageIndex === 0}
        >
          <ChevronLeft className="tw-h-4 tw-w-4" />
          Previous
        </Button>
        <span className="tw-text-sm tw-text-muted-foreground">
          Page{" "}
          <span className="tw-font-medium tw-text-foreground">{pageIndex + 1}</span>{" "}
          of{" "}
          <span className="tw-font-medium tw-text-foreground">{totalPages || 1}</span>
        </span>
        <Button
          variant="outline"
          size="sm"
          className="tw-h-8 tw-gap-1"
          onClick={() => onPageChange(pageIndex + 1)}
          disabled={pageIndex >= totalPages - 1}
        >
          Next
          <ChevronRight className="tw-h-4 tw-w-4" />
        </Button>
      </div>
    </div>
  );
}
